<template>
  <div class="home">
	  <Header>
			<div class="leftcss"><span id="show-modal" @click="showModal = true"><i class="iconfont icon-zhedie1"></i></span><modal v-if="showModal" @close="showModal = false" > </modal></div>
			     <div class="centercss"><img style="max-height: 3.5vmax; width: auto;" src="../assets/logo.png" /></div>
			</Header>
    <IndexMain/>
		<Footer/> 
  </div>
	
	
</template>

<script>
// @ is an alias to /src
 
import Header from '@/components/Header.vue'
import IndexMain from '@/components/IndexMain.vue'
import Footer from '@/components/MFooter.vue'
import modal from '@/components/modal.vue'
export default {
  name: 'home',
    data(){
  	  return{
  		  showModal: false,
  	  }
  },
  components: {
		 Header,
     IndexMain,
		 Footer,
		 modal
		
  }
}
</script>
<style>
		
	.homeleftcss{
margin-left: 4vw;
	}

	 
</style>
